import React from 'react';
import _ from 'lodash';
import ArrowDown from './icons/ArrowDown';
import ArrowUp from './icons/ArrowUp';

// import { assetsPath } from '../utils'
// const downGreen = `${assetsPath()}/images/icon/down-green.png`;


// const SM_MIN_WIDTH = 0
// const SM_MAX_WIDTH = 576

// const LG_MIN_WIDTH = 576
// const LG_MAX_WIDTH = 1140

// if (isLg) offset = -152;
// if (isSm) offset = -90;

class ButtonScrollToSection extends React.Component {
  componentDidMount = () => {
    this.sections = document.querySelectorAll('.main-content section');
    this.firstSection = this.sections[0];
    this.lastSection = this.sections[this.sections.length - 1];
    this.btnUp = document.querySelector('.button-scroll-to-section.up');
    this.btnDown = document.querySelector('.button-scroll-to-section.down');

    window.addEventListener('scroll', this.handleVisibleButtonScroll);
    this.handleVisibleButtonScroll();
  }
  componentWillUnMount = () => {
    window.removeEventListener('scroll');
  }

  getHeaderHeight = () => {
    const header = document.getElementsByTagName('header')[0];
    let headerHeight = header.offsetHeight;

    // Prevent calculate headerheight wrong, due to shrink animation
    if (window.innerWidth > 1200 && document.documentElement.scrollTop < 100) headerHeight = 86;

    return headerHeight;
  }

  handleVisibleButtonScroll = () => {

    if (window.pageYOffset > this.firstSection.offsetHeight) {
      // console.log('show top bottom');
      this.btnUp.classList.remove('hide');
    } else {
      // console.log('hide top bottom');
      this.btnUp.classList.add('hide');
    }
    if (window.pageYOffset <= this.lastSection.offsetTop) {
      // console.log('show down bottom');
      this.btnDown.classList.remove('hide');
    } else {
      // console.log('hide down bottom');
      this.btnDown.classList.add('hide');
    }
  }

  handleScroll = (direction) => {
    const sections = document.querySelectorAll('.main-content section');
    let headerHeight = this.getHeaderHeight();
    _.forEach(sections, (section, sectionIndex) => {
      const stickyTop = section.offsetTop;
      const stickyBottom = stickyTop + section.offsetHeight;
      if (window.pageYOffset + headerHeight >= stickyTop && window.pageYOffset + headerHeight <= stickyBottom) {
        const nextIndex = (direction === 'up') ? sectionIndex - 1 : sectionIndex + 1;
        const nextSection = sections[nextIndex];
        if (nextSection) {
          const scrollTargetValue = (direction === 'up') ? nextSection.offsetTop - headerHeight : nextSection.offsetTop - headerHeight;
          $('html, body').stop().animate({ scrollTop: scrollTargetValue }, 800); // eslint-disable-line
          return false
        }
        return false
      }
    })
  }

  handleScrollUp = () => {
    this.handleScroll('up');
  }

  handleScrollDown = () => {
    this.handleScroll('down');
  }


  render() {
    return (
      <React.Fragment>
        <button onClick={this.handleScrollUp} className="button-scroll-to-section up">
          <ArrowUp width={40} height={40} fill="#04a8a6" />
        </button>
        <button onClick={this.handleScrollDown} className="button-scroll-to-section down">
          <ArrowDown width={40} height={40} fill="#04a8a6" />
        </button>
      </React.Fragment>
    );
  }
}

export default ButtonScrollToSection;



// WEBPACK FOOTER //
// ./src/components/ButtonScrollToSection.js